@if (hasToasts()) {
  <div class="toast-stack" role="status" aria-live="polite">
    @for (toast of toasts(); track toast.id) {
      <div
        class="toast-item"
        [class.fading]="toast.fading"
        [attr.data-type]="toast.type">

        <span class="toast-icon">{{ typeIcon(toast.type) }}</span>

        @if (toast.title) {
          <span class="toast-title">{{ toast.title }}</span>
        }
        <span class="toast-message">{{ toast.message }}</span>

        @if (toast.actionLabel) {
          <button class="toast-action" (click)="executeAction(toast.id)">
            {{ toast.actionLabel }}
          </button>
        }

        @if (toast.actions.length) {
          <div class="toast-actions" role="group">
            @for (action of toast.actions; track $index; let i = $index) {
              <button
                class="toast-combo-btn"
                [class.primary]="action.kind === 'primary'"
                [class.secondary]="action.kind !== 'primary'"
                (click)="executeActionAt(toast.id, i)">
                {{ action.label }}
              </button>
            }
          </div>
        }
        <button
          class="toast-dismiss"
          (click)="dismiss(toast.id)"
          [attr.aria-label]="'toast.dismiss' | t">&times;</button>
      </div>
    }
  </div>
}
